import { Check } from "lucide-react";
import { wizardSteps } from "@/config";

const stepCircleStyles = ({ isCurrent, isCompleted }) => {
  if (isCurrent) {
    return { background: "var(--pp-indigo)", color: "#fff", borderColor: "var(--pp-indigo)" };
  }
  if (isCompleted) {
    return { background: "var(--pp-gold)", color: "var(--pp-ink)", borderColor: "var(--pp-gold)" };
  }
  return { background: "#fff", color: "var(--pp-muted)", borderColor: "var(--pp-border)" };
};

const stepLabelColor = ({ isCurrent, isCompleted }) => {
  if (isCurrent) return "var(--pp-indigo)";
  if (isCompleted) return "var(--pp-ink)";
  return "var(--pp-muted)";
};

export default function StepIndicator({ currentStep, completedSteps, onJumpTo }) {
  return (
    <ol className="flex items-center justify-between w-full mb-4 gap-1" data-testid="step-indicator">
      {wizardSteps.map((s) => {
        const isCompleted = completedSteps.has(s.id);
        const isCurrent = currentStep === s.id;
        const clickable = isCompleted && currentStep !== s.id;
        const flags = { isCurrent, isCompleted };

        return (
          <li
            key={s.id}
            className="flex-1 flex flex-col items-center gap-1 text-center"
            data-testid={`step-${s.id}-indicator`}
          >
            <button
              type="button"
              onClick={clickable ? () => onJumpTo(s.id) : undefined}
              disabled={!clickable}
              aria-current={isCurrent ? "step" : undefined}
              className="w-7 h-7 sm:w-8 sm:h-8 rounded-full border-2 flex items-center justify-center text-xs sm:text-sm font-semibold transition-all"
              style={stepCircleStyles(flags)}
              data-testid={`step-${s.id}-button`}
            >
              {isCompleted ? <Check className="w-3.5 h-3.5" strokeWidth={3} /> : s.id}
            </button>
            <span
              className="text-[10px] sm:text-xs font-medium leading-tight"
              style={{ color: stepLabelColor(flags) }}
            >
              {s.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
